import { NavLink, Outlet } from "react-router-dom";
import { Zap, Target, AlertTriangle, BarChart3 } from "lucide-react";

const TABS = [
  { to: "interventions", label: "Activités", icon: Zap },
  { to: "plans", label: "Plans d'action", icon: Target },
  { to: "alertes", label: "Alertes terrain", icon: AlertTriangle },
  { to: "sondages", label: "Sondages", icon: BarChart3 },
];

export default function CentreOperations() {
  return (
    <div className="space-y-4" data-testid="centre-ops-page">
      <h1 className="font-display text-2xl font-bold tracking-tight text-slate-900 leading-none">Centre des opérations terrain</h1>
      <div className="flex items-center gap-2 border-b border-slate-200 flex-wrap">
        {TABS.map(t => {
          const Icon = t.icon;
          return (
            <NavLink key={t.to} to={t.to} data-testid={`ops-tab-${t.to}`}
              className={({ isActive }) => `flex items-center gap-1.5 px-4 py-2 text-[13px] font-semibold border-b-2 transition ${isActive ? "border-blue-600 text-blue-600" : "border-transparent text-slate-500 hover:text-slate-700"}`}>
              <Icon className="w-3.5 h-3.5" /> {t.label}
            </NavLink>
          );
        })}
      </div>
      <Outlet />
    </div>
  );
}
